import { Moon, Sun } from 'lucide-react';

import { useTheme } from '../theme/use-theme.js';

/**
 * Switches between light and dark for this device only.
 *
 * The choice is never written to the account, so one person switching to dark
 * does not flip it for everyone else signed in.
 */
export function ThemeToggleButton() {
  const { resolvedTheme, toggleTheme } = useTheme();
  const goingDark = resolvedTheme !== 'dark';

  return (
    <button
      type="button"
      className="icon-btn"
      onClick={toggleTheme}
      aria-pressed={resolvedTheme === 'dark'}
      aria-label={goingDark ? 'Switch to dark mode' : 'Switch to light mode'}
    >
      {resolvedTheme === 'dark' ? (
        <Sun size={16} aria-hidden="true" />
      ) : (
        <Moon size={16} aria-hidden="true" />
      )}
    </button>
  );
}
